<template>
    <div class="form-group">
        <label for="">會員資料</label>
        <input type="text" class="form-control" id="name" placeholder="姓名" />
        <input type="text" class="form-control" id="phone" placeholder="手機" />
        <user-address v-model="profile.address"></user-address>
    </div>
</template>
<script>
    import ComponentAPIVue from "../../ComponentAPI.vue";
    export default {
        extends: ComponentAPIVue,
        data() {
            return {
                profile: {
                    address: {
                        city_id: undefined,
                        dist_id: undefined,
                        road: undefined,
                    },
                },
                debugFlag: true,
            };
        },
        mounted() {
        },
        methods: {
        },
    };
</script>
<style lang="">
</style>